// @ts-nocheck
import { LocalizationEntity } from '../../../../shared/models/localization';
import LocalizationHelper from '../../../../helpers/TranslationHelper';

export const ValidateTimes = (
  localization: LocalizationEntity[],
  startOfWorkingDay: string,
  endOfWorkingDay: string,
  startOfLunch: string,
  endOfLunch: string
): string | null => {
  const parseTimeToMinutes = (time: string | null): number | null => {
    if (!time) return null;

    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const TimeValidationErrors = {
    MissingWorkingHours: LocalizationHelper.getLocaleEntityValue(
      localization,
      'ZSite.Frontend.MissingWorkingHours',
      'All time fields (Start of Working Day and End of Working Day) must be filled.'
    ),
    InvalidWorkingHours: LocalizationHelper.getLocaleEntityValue(
      localization,
      'ZSite.Frontend.InvalidWorkingHours',
      'Start of working day must be earlier than end of working day.'
    ),
    InvalidLunchTime: LocalizationHelper.getLocaleEntityValue(
      localization,
      'ZSite.Frontend.InvalidLunchTime',
      'Lunch start time must be earlier than lunch end time.'
    ),
    LunchOutsideWorkingHours: LocalizationHelper.getLocaleEntityValue(
      localization,
      'ZSite.Frontend.LunchOutsideWorkingHours',
      'Lunch time must fit within the working hours.'
    ),
  };

  const startWorking = parseTimeToMinutes(startOfWorkingDay);
  const endWorking = parseTimeToMinutes(endOfWorkingDay);
  const startLunch = parseTimeToMinutes(startOfLunch);
  const endLunch = parseTimeToMinutes(endOfLunch);

  if (!startWorking || !endWorking) {
    return TimeValidationErrors.MissingWorkingHours;
  }

  if (startWorking >= endWorking) {
    return TimeValidationErrors.InvalidWorkingHours;
  }

  if (startLunch || endLunch) {
    if (startLunch >= endLunch) {
      return TimeValidationErrors.InvalidLunchTime;
    }

    if (startLunch <= startWorking || endLunch >= endWorking) {
      return TimeValidationErrors.LunchOutsideWorkingHours;
    }
  }

  return null;
};
